import React from 'react';
import { AvatarWithLabel, Card, CardContent, CardHeader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { MainContent } from 'app/domains/common-ui';
import useAccount from '../../../../../shared/domains/users/hooks/useAccount';
import { CustomGrid, Column, CustomerDetailsTitle, CustomerDetailsValue, CopyButton, CustomerDetailsContent, } from './styled';
function CustomerDetails(props) {
    const { title, value } = props;
    const handleCopy = () => {
        navigator.clipboard.writeText(value);
    };
    return (<CustomerDetailsContent>
      <CustomerDetailsTitle>{title}</CustomerDetailsTitle>
      <CustomerDetailsValue>
        {value}
        <CopyButton size="xs" appearance="ghost" onClick={handleCopy}>
          <Falcon icon="copy"/>
        </CopyButton>
      </CustomerDetailsValue>
    </CustomerDetailsContent>);
}
export function CustomerSuccess() {
    const { data } = useAccount();
    return (<MainContent>
      <CustomGrid>
        <Column width="100%">
          <Card>
            <CardHeader media={<AvatarWithLabel size="xl" shape="square" title="Company Details">
                  <Falcon icon="list-ul"/>
                </AvatarWithLabel>}/>
            <CardContent>
              <CustomerDetails title="Company Name" value={data.company.name}/>
              <CustomerDetails title="Company ID" value={data.company.id}/>
            </CardContent>
          </Card>
        </Column>
      </CustomGrid>
    </MainContent>);
}
